import { useCallback, useMemo } from 'react';
import QRCard from './QRCard';
import LinkedConfig from './LinkedConfig';
import { useAuth } from '../../../utils/Auth';
import { useFilteredAndSortedQRs } from '../../../utils/hooks/useFilteredAndSortedQrs';
import styles from './LinkQR.module.css';

export default function LinkQR({ parent, setParent }) {

    const { liquidQRs, orgObj } = useAuth();

    const [ filters, setFilters, filteredQrs ] = useFilteredAndSortedQRs(liquidQRs);
    const { searchValue, categoryValue, searchType } = filters;
    
    const categories = useMemo(() => orgObj?.categories, [orgObj?.categories]);

    const parentQrs = filteredQrs?.filter(qr => qr.data.qr_type !== 'liquid_link');

    const handleFilterChange = useCallback((key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    }, [setFilters]);

    const handleSearchType = useCallback((type) => {
        handleFilterChange('searchType', type);
        handleFilterChange('searchValue', '');
    }, [handleFilterChange]);

    const renderSearchResult = () => {
        const categoryDisplay = categories?.find(cat => cat.id === categoryValue)?.name;

        if (!parentQrs || parentQrs.length === 0) {
            return (
                <div className={styles.resultMessage}>
                    No QRs were found. Try another search or category.
                </div>
            );
        }

        return (
            <>
            <div className={styles.resultMessage}>
                {searchValue?.length > 0 && (
                    <div className={styles.resultMessageInfo}>
                        Search: <span className={styles.bold}>{searchValue}</span>
                    </div>
                )}
                {categoryValue && categoryDisplay && (
                    <div className={styles.resultMessageInfo}>
                        Category: <span className={styles.bold}>{categoryDisplay}</span>
                    </div>
                )}
            </div>
            <div className={styles.qrContainer}>
                {parentQrs.map(qr => (
                    <QRCard key={qr.id} QR={qr} setParent={setParent} />
                ))}
            </div>
            </>
        )
    };

    if (parent.selected) {
        return <LinkedConfig />
    }

    return (
        <div className={styles.container}>
            <div className={styles.searchContainer}>
                <div className={styles.searchInner}>
                    <label htmlFor='search-name'>Search by Name</label>
                    <input 
                        type='radio' 
                        id='search-name' 
                        checked={searchType === 'name'} 
                        onChange={() => handleSearchType('name')} />
                    <label htmlFor='search-tag'>Search by Tag</label>
                    <input 
                        type='radio' 
                        id='search-tag' 
                        checked={searchType === 'tag'} 
                        onChange={() => handleSearchType('tag')} />
                </div>
                <input 
                    type='text' 
                    placeholder='Search...' 
                    className={styles.input} 
                    value={searchValue} 
                    onChange={(e) => handleFilterChange('searchValue', e.target.value)} 
                    maxLength='30'
                />
                {categories?.length > 0 && (
                    <div className={styles.selectGroup}>
                        <select 
                            className={styles.select} 
                            value={categoryValue || '0'} 
                            onChange={(e) => handleFilterChange('categoryValue', e.target.value === 'Clear Filter' ? '' : e.target.value)} 
                            disabled={!categories}
                        >
                            <option value='0' disabled>Category Filter</option>
                            {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                            <option value='Clear Filter'>Clear Category Filter</option>
                        </select>
                    </div>
                )}
            </div>
            <div className={styles.resultContainer}>
                {renderSearchResult()}
            </div>
        </div>
    );
};